import * as React                        from 'react';
import {createElement}                   from 'react';
import {Route, Switch, Redirect}         from 'react-router-dom';

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Invoke}         from "@Common/react/invoke";
import {isDevQuan}      from "@Common/ui-components/debug/is-dev-quan";

import {AccountRoutes}                      from "./account/account-routes";
import {CategoryListRoute}                  from "./category-list/category-list-route";
import {customizeRoutes}                    from "./customize/customize-routes";
import {DevTemp}                            from "./dev-temp/dev-temp";
import {GuestRouteSwitch}                   from "./guest-route-switch";
import {ManageHeadshotsRoute}               from "./manage-headshots/manage-headshots-route";
import {URL_BASE_MARKETING_CENTER}          from "./marketing-center/common/marketing-center-common";
import {MarketingCenterLayout}              from "./marketing-center/layout/marketing-center-layout";
import {MyListingsRoute}                    from "./my-listings/my-listings-route";
import {OrdersRoute}                        from "./orders/orders-route";
import {PasswordRoute}                      from './password/password';
import {ProductsRoute}                      from "./products-route/products-route";
import {QAResponsiveRoute}                  from "./qa-responsive/qa-responsive";
import {QRRoute}                            from "./qr/qr-route";
import {SearchRoute}                        from "./search/search-route";
import {OmniSearchRoute, ROUTE_OMNISEARCH}  from "./omni-search/omni-search-route";
import {Error}                              from "./sso/error/error";
import {TestRoute}                          from './sso/test/test';
import {SubCategoryListRoute}               from "./sub-category-list/sub-category-list-route";
import {SubscriptionsRoute}                 from "./subscriptions/subscriptions-route";
import {SupportRoute}                       from "./support/support";
import {UserCreatedRoutes}                  from "./user-created/user-created-routes";
import {BrandedLoginRoute}                  from "./brand/branded-login-route";
import {ReceiptRoute}                       from "./receipt/receipt-route";
import {XpresslinksLanding}                 from './account/orders/history-route/xpresslinks-route/xpresslinks-landing';

export const RouteSwitch = () => cs(
    ({}, next) => isDevQuan() ? next() : cs(
        // guest hijack
        consumeContext("themeScheme"),
        consumeContext("routerHistory"),
        ({themeScheme, routerHistory}, next) => (
            themeScheme.type === "ssoGuest" ||
            window.location.pathname.includes(themeScheme?.companyXdocsUrl)
        ) ? (
            next()
        ) : (
            Invoke({
                action: () =>
                    routerHistory.replace(window.location.pathname.replace('/app','') + window.location.search),
            })
        ),
        ({themeScheme}) => (
            themeScheme.type === "limitedGuest" || themeScheme.type === "ssoGuest"
        ) ? GuestRouteSwitch() : next(),
    ),

    ["userCreatedRoutes", ({}, next) => UserCreatedRoutes({next})],
    ["accountRoutes", ({}, next) => AccountRoutes({next})],
    ({accountRoutes, userCreatedRoutes}) => (
        <Switch>
            <Route
                exact
                path={"/"}
                render={() => (
                    <CategoryListRoute/>
                )}
            />
            <Route
                exact
                path={"/list-selected"}
                render={() => (
                    <CategoryListRoute/>
                )}
            />
            <Route
                exact
                path={"/cat/:cat_id"}
                render={(props) => (
                    <SubCategoryListRoute {...props} />
                )}
            />
            <Route
                exact
                path={"/cat/:cat_id/sub/:sub_id"}
                render={(props) => (
                    <ProductsRoute {...props}/>
                )}
            />

            {/* DEPRECATED */}
            <Route
                exact
                path={"/sub/:sub_id/product/:product_id"}
                render={({match}) => (
                    <Redirect to={`/product-options/${match.params.product_id}`}/>
                )}
            />
            <Route
                exact
                path={"/product/:product_id"}
                render={({match}) => (
                    <Redirect to={`/product-options/${match.params.product_id}`}/>
                )}
            />
            <Route
                exact
                path={"/search"}
                render={() => (
                    <SearchRoute/>
                )}
            />

            <Route
                exact
                path={"/approval-requests"}
                render={() => (
                    <Redirect to="/account/orders/approval"/>
                )}
            />

            <Route
                exact
                path="/manage-headshots"
                component={ManageHeadshotsRoute}
            />

            {accountRoutes}

            <Route
                exact
                path={URL_BASE_MARKETING_CENTER + "/home"}
                render={() => (
                    <Redirect
                        to={URL_BASE_MARKETING_CENTER}
                    />
                )}
            />

            <Route
                exact
                path={URL_BASE_MARKETING_CENTER}
                component={MarketingCenterLayout}
            />

            {customizeRoutes.map((route, i) => (
                <Route
                    key={i}
                    exact
                    path={route.path}
                    render={(props) => {
                        return createElement(route.component, props);
                    }}
                />
            ))}

            <Route
                exact
                path={"/listings"}
                render={() => (
                    <MyListingsRoute/>
                )}
            />

            <Route
                exact
                path={"/manage-subscriptions"}
                render={(props) => (
                    <SubscriptionsRoute {...props}/>
                )}
            />
            <Route
                exact
                path={"/orders"}
                component={OrdersRoute}
            />
            <Route
                exact
                path={"/xpresslinks/:orderParams"}
                render={(props) => (
                    <XpresslinksLanding {...props}/>
                )}
            />
            <Route
                exact
                path={"/sso/error"}
                render={() => (
                    <Error/>
                )}
            />
            <Route
                exact
                path={"/sso/test"}
                render={() => (
                    <TestRoute/>
                )}
            />

            {userCreatedRoutes.map((route, i) => (
                <Route
                    key={i}
                    exact
                    path={route.path}
                    render={(props)=> {
                        return route.allowed ? createElement(route.component, props) : <Redirect to="/" />;
                    }}
                />
            ))}

            <Route
                exact
                path={"/my-templates"}
                render={() => (
                    <></>//TODO: MyTemplate Route. Utilizes user created template for order flow. <UserCreatedAdminRoute/>
                )}
            />

            <Route
                exact
                path="/support"
                component={SupportRoute}
            />

            <Route
                exact
                path="/password"
                component={PasswordRoute}
            />

            <Route
                exact
                path={"/dev-temp"}
                render={() => (
                    <DevTemp/>
                )}
            />
            <Route
                exact
                path={"/dev-qr"}
                component={QRRoute}
            />
            <Route
                exact
                path="/😸"
                component={QAResponsiveRoute}
            />

            <Route
                exact
                path={ROUTE_OMNISEARCH.BROWSE}
                render={() => (
                    <OmniSearchRoute/>
                )}
            />
            <Route
                exact
                path={ROUTE_OMNISEARCH.EXPLORE}
                render={() => (
                    <OmniSearchRoute/>
                )}
            />
            <Route
                exact
                path={ROUTE_OMNISEARCH.PRODUCTS}
                render={() => (
                    <OmniSearchRoute/>
                )}
            />

            <Route
                exact
                path={"/branded"}
                component={BrandedLoginRoute}
            />
            <Route
                exact
                path={"/receipt/:cart_id"}
                render={(props) => (
                    <ReceiptRoute {...props} />
                )}
            />

            <Redirect to={"/"}/>
        </Switch>
    )
);
